import { httpService } from "common/services";
import { AUTH_URL } from "config/constants";
import { PasswordResetInterface } from "models/Auth";

export async function resetPassword(data: PasswordResetInterface, token: string): Promise<any> {
    const res = await httpService.request({ data, headers: { Authorization: `Bearer ${ token }` }, method: "POST", url: `${ AUTH_URL }reset-password` });
    return res.data;
}